/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Combo_Recipe_EmptyInputs */

const vi_combo_recipe_empty = /** @type {(inputs: Combo_Recipe_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có thành phần. Thêm dòng để cấu hình.`)
};

/**

* @param {Combo_Recipe_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const combo_recipe_empty = /** @type {((inputs?: Combo_Recipe_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Combo_Recipe_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_combo_recipe_empty(inputs)
});